import { DeleteCandidateDocument, DeleteCandidateMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteCandidate = (id: number) => {
  const [deleteCandidateMutation, { loading }] = useMutation(DeleteCandidateDocument, {
    extractorFn: (data: DeleteCandidateMutation) => data.atsMutations.deleteAtsCandidate,
  })

  return {
    loading,
    deleteCandidate() {
      return deleteCandidateMutation({
        variables: { id },
        update(cache) {
          cache.evict({ id: cache.identify({ id: id, __typename: 'AtsCandidate' }) })
        },
      })
    },
  }
}
